(function(){
"use strict";
var hero=document.querySelector(".dmh");
if(!hero)return;

/* il pulsante porta ai prodotti restando sulla pagina */
var cta=document.getElementById("dmhVai");
if(cta)cta.addEventListener("click",function(e){
 e.preventDefault();
 var meta=document.querySelector(".dcol .griglia")||hero;
 var y=meta.getBoundingClientRect().top+pageYOffset-70;
 scrollTo({top:y,behavior:"smooth"});
});

/* parallasse leggero, solo da computer */
if(matchMedia("(min-width:641px)").matches){
 hero.addEventListener("mousemove",function(e){
  var r=hero.getBoundingClientRect();
  var x=(e.clientX-r.left)/r.width-.5;
  var y=(e.clientY-r.top)/r.height-.5;
  var orb=hero.querySelectorAll(".orb");
  for(var i=0;i<orb.length;i++){
   var f=(i+1)*8;
   orb[i].style.transform="translate("+(x*f)+"px,"+(y*f)+"px)";
  }
 });
 hero.addEventListener("mouseleave",function(){
  var orb=hero.querySelectorAll(".orb");
  for(var i=0;i<orb.length;i++)orb[i].style.transform="";
 });
}
})();
